import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { reminder } from '../../../../model/reminder';

export interface IActions {
    loadReminders: (sub: string) => Promise<Array<reminder>>;
    saveReminder: (reminder: reminder) => Promise<reminder>;
    loadContactReminders: (sub: string) => Promise<reminder>;
    addReminder: (reminder: reminder) => Promise<reminder>;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadReminders: (sub: string) => {
            var activeApi = "/api/Reminders";
            if (sub && sub !== "") {
                 activeApi = "/api/Contact/" + sub + "/Reminders";
            }
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADREMINDERS,
                    payload: invokeApi({
                        path: activeApi,
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        saveReminder: (reminder: reminder) => {
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.SAVEREMINDER,
                    payload: invokeApi({
                        path: '/api/Contact/' + reminder.userId + '/Reminders',
                        method: 'PUT',
                        body: reminder,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
        loadContactReminders: (sub: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADCONTACTSREMINDERS,
                    payload: invokeApi({
                        path: "/api/Contact/" + sub + "/Reminders",
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        addReminder: (reminder: reminder) => {
            if (reminder.blockAccess) {
                dispatch({
                    type: Keys.ADDBLOCKACCESSDATE,
                    payload: reminder.expiresOn 
                });
            }
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.ADDREMINDER,
                    payload: invokeApi({
                        path: '/api/Contact/' + reminder.userId + '/Reminders',
                        method: 'POST',
                        body: reminder,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
    }
}